module.exports = __webpack_public_path__ + "static/media/29FUNOV15.c96737c8.jpg";